import React, { useState } from 'react'
import { NuevaOrdenCompra } from './NuevaOrdenCompra'
import { OrdenLista } from './OrdenLista'
import { Modal, Icon, Dropdown } from 'semantic-ui-react'

const OrdenCompra = (props) => {
    const [open, setOpen] = useState(false)
    const [filtro, setFiltro] = useState('pendingApproval')

    const handleStatusFilterChange=(e, {value})=>{
        setFiltro(value)
    }
    return (
        <>
        <div className='filtros'>
            <Dropdown
                selection
                options={[
                    {key:1, text:'Pendientes', value:'pendingApproval'},
                    {key:2, text:'Completados', value:'cerrado'},
                    {key:3, text:'Todos', value:'all'},
                ]}
                name='status'
                value={filtro}
                onChange={handleStatusFilterChange}
            />
            <Modal
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                open={open}
                trigger={<button><Icon name='plus' />Nuevo</button>}
            >
                <Modal.Header>Nueva orden de Compra</Modal.Header>
                <Modal.Content>
                    <NuevaOrdenCompra onSave={()=>{setOpen(false)}}></NuevaOrdenCompra>
                </Modal.Content>
            </Modal>
        </div>
        <OrdenLista key={filtro} filtro={filtro}/>
        </>
    )
}

export default OrdenCompra